import { useState } from "react";
import { BRAIN_API } from "../../lib/founderApi";

export function LoginView({ onRequested }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const request = async (e) => {
    e.preventDefault();
    await fetch(`${BRAIN_API}/founder/magic-link`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });
    setSent(true);
    onRequested?.();
  };
  return (
    <div className="min-h-screen bg-[#FAF7F2] flex items-center justify-center p-6">
      <div className="bg-white border border-[#E5E0D8] max-w-md w-full p-10" data-testid="founder-login">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#0B3D5C] mb-3">
          LeadRiver · Company Brain
        </p>
        <h1 className="text-3xl font-extrabold tracking-tight mb-3">Founder access.</h1>
        {sent ? (
          <p data-testid="magic-link-sent" className="text-[#4A4A4A]">
            If that's the founder email, a sign-in link is in your inbox. It
            works once and expires in 15 minutes.
          </p>
        ) : (
          <form onSubmit={request} className="grid gap-3">
            <input
              data-testid="founder-email-input"
              type="email"
              required
              placeholder="Founder email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border border-[#E5E0D8] bg-[#FAF7F2] px-3 py-2.5 text-sm focus:outline-none focus:border-[#0B3D5C]"
            />
            <button
              data-testid="magic-link-request-btn"
              className="bg-[#E07B3A] text-white font-bold py-2.5 text-sm"
            >
              Send magic link
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
